import * as React from 'react'
import { useTranslation } from 'react-i18next'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import AccountCircle from '@mui/icons-material/AccountCircle'
import NotificationsIcon from '@mui/icons-material/Notifications'
import MoreIcon from '@mui/icons-material/MoreVert'
import logo from './images/logo.png'
import { NavLink, useLocation } from 'react-router-dom'
import SimpleListMenu from './NavMenu'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import StarBorder from '@mui/icons-material/StarBorder'
import {
  Badge,
  Collapse,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  List,
  ListItemButton,
  Tab,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { TextField, Button, MenuList, ListItemIcon, ListItemText } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import SettingsIcon from '@mui/icons-material/Settings'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import AppRegistrationIcon from '@mui/icons-material/AppRegistration'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import DvrRoundedIcon from '@mui/icons-material/DvrRounded'
import { useNavigate } from 'react-router'
import PersonIcon from '@mui/icons-material/Person'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import urls from 'utils/urls'
import { makeGetRequest, makePatchRequest } from 'utils/api'
import Slide from '@mui/material/Slide'
import Dialog from '@mui/material/Dialog'
import { useEffect, useState } from 'react'
import UserOptions from './UserOptions'
import { setSiteUser } from 'reduxLib/slices/userSlice'
import { clearClientSession } from 'utils/session'
import { useDispatch } from 'react-redux'
import { setSitePersonnaliser } from 'reduxLib/slices/userSlice'
import { useForm } from 'react-hook-form'
import { makePostRequest, getWsUrl } from 'utils/api'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import WebSocket from 'react-websocket'
import CloseIcon from '@mui/icons-material/Close'
import moment from 'moment'
import Typography from '@mui/material/Typography'
import InputAdornment from '@mui/material/InputAdornment'
import ClearIcon from '@mui/icons-material/Clear'
import i18n, { SUPPORTED_LANGUAGES } from '../i18n' // LAP-733

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const NavBar2 = ({ setUserSync, setIsLoading }) => {
  const { t } = useTranslation(['layout', 'common'])
  let location = useLocation()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [anchorNfEl, setAnchorNfEl] = React.useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)
  const inputQuery = React.useRef()
  const isMenuOpen = Boolean(anchorEl)
  const isMenuNFOpen = Boolean(anchorNfEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
  const [table, setTable] = React.useState(0)
  const [query, setQuery] = React.useState('')
  const [tables, setTables] = React.useState({})
  const [suggestion, setSuggestion] = React.useState([])
  const [suggestionFilter, setSuggestionFilter] = React.useState([])
  const [openSearch, setOpenSearch] = React.useState(false)
  const [openSuggestion, setOpenSuggestion] = React.useState(false)
  const [user, setUser] = React.useState({})
  const [uoption, setUoption] = React.useState(false)
  const [cPOpen, setCPOpen] = React.useState(false)
  const [appDetailOpen, setAppDetailOpen] = React.useState(false)
  const dispatch = useDispatch()

  const token = localStorage.getItem('token')
  const [messages, setMessages] = useState([])
  const [messagesType, setMessagesType] = useState([])
  const [messagesPriority, setMessagesPriority] = useState([])
  const messagesList = React.useRef()
  const [tabValue, setTabValue] = React.useState('1')
  const opencc = localStorage.getItem('opencc')

  const handleChangeTab = (event, newValue) => {
    let mlist = [...messagesList.current]
    if (newValue === '3') {
      mlist.sort((a, b) => parseInt(a.priority_obj.priority) - parseInt(b.priority_obj.priority))
      setMessagesPriority(mlist)
    }
    if (newValue === '2') {
      let mgroup = []
      let mgroupList = []
      mlist.sort((a, b) => a.source.localeCompare(b.source))
      mlist.forEach((e) => {
        if (mgroup.includes(e.source)) {
          mgroupList.filter((el) => el.type === e.source)[0].list.push(e)
        } else {
          mgroup.push(e.source)
          mgroupList.push({ type: e.source, list: [e], open: false })
        }
      })
      setMessagesType(mgroupList)
    }

    setTabValue(newValue)
  }
  //   const [token, setToken] = useState('your-auth-token');

  // Mobile (Capacitor) — URL dérivée du backend configuré (wss:// en prod),
  // plus de fallback ws:// codé en dur.
  const wsUrl = `${getWsUrl()}/ws/notifications/?app=${token}`
  const handleData = (data) => {
    let tt = localStorage.getItem('token')
    if (!tt) {
      clearClientSession(dispatch)
      navigate('/login')
    }
    let result = JSON.parse(data)
    if (messagesList.current) {
      messagesList.current = [...messagesList.current, result]
    } else {
      messagesList.current = [result]
    }
    // let bspan = document.getElementById('notifi-counter').getElementsByClassName('MuiBadge-badge')
    // if (bspan.length > 0) {
    //   bspan[0].innerHTML = messagesList.current.length
    // }
    // console.log(bspan[0].innerHTML)
    setMessages((prev) => [result, ...prev])
    setTabValue('1')
    // console.log(messagesList.current)
  }

  useEffect(() => {
    fetchUser()
  }, [])
  useEffect(() => {
    if (opencc) {
      setUoption(true)
    }
    // console.log(location.pathname)
    // if (location.pathname === '/oauth2callback') {
    //   localStorage.setItem('opencc', true)
    //   setUoption(true)
    // }
  }, [])
  // GE0010 : la carte SmartFeed « Personnalise tes notifications » demande
  // l'ouverture du dialogue Réglages via un événement window (la NavBar est
  // déjà montée, un simple navigate ne suffit pas). L'onglet cible est porté
  // par le flag localStorage 'opennt', lu par UserOptions (pattern opencc/openab).
  useEffect(() => {
    const openUserOptions = () => setUoption(true)
    window.addEventListener('open-user-options', openUserOptions)
    return () => window.removeEventListener('open-user-options', openUserOptions)
  }, [])
  const fetchUser = async () => {
    try {
      const response = await makeGetRequest('/api/user/user/', {}, true)

      if (response.status === 200) {
        dispatch(setSiteUser(response.data))
        setUser(response.data)
        // LAP-733 (GE022) + LAP-752: reconcile UI language with the user's
        // preference. Two scenarios to handle:
        //   1. The user picked a language explicitly on the auth pages
        //      (LanguageSelector with disablePersist=true wrote
        //      `i18nExplicitChoice` to localStorage). That choice MUST win,
        //      because the backend may still hold the default `fr` from a
        //      pre-i18n-aware signup. Push it up via PATCH so the user keeps
        //      that language across devices, then clear the marker.
        //   2. No explicit choice was made → trust the backend value.
        try {
          let explicitChoice = null
          try {
            explicitChoice = window.localStorage.getItem('i18nExplicitChoice')
          } catch (_) {
            explicitChoice = null
          }

          const backendLang = response.data?.language
          const validExplicit =
            explicitChoice && SUPPORTED_LANGUAGES.includes(explicitChoice)

          if (validExplicit && explicitChoice !== backendLang) {
            // Explicit local pick takes precedence — sync it to the backend.
            if (i18n.language !== explicitChoice) {
              i18n.changeLanguage(explicitChoice)
            }
            try {
              await makePatchRequest(
                '/api/user/preferences/',
                { language: explicitChoice },
                {},
                true,
              )
            } catch (_) {
              // Best-effort; UI already switched locally.
            }
            try {
              window.localStorage.removeItem('i18nExplicitChoice')
            } catch (_) {}
          } else if (
            backendLang &&
            SUPPORTED_LANGUAGES.includes(backendLang) &&
            i18n.language !== backendLang
          ) {
            i18n.changeLanguage(backendLang)
          }
        } catch (_) {
          // never block the auth flow on i18n errors
        }
        getNotifications()
        setUserSync(true)
        if (setIsLoading) setIsLoading(false)
      } else {
        setUserSync(false)
        if (setIsLoading) setIsLoading(false)
        clearClientSession(dispatch)
        navigate('/login')
      }
    } catch (error) {
      console.error('Error fetching user:', error)
      setUserSync(false)
      if (setIsLoading) setIsLoading(false)
      clearClientSession(dispatch)
      navigate('/login')
    }
  }
  const getNotifications = async () => {
    const response = await makeGetRequest('/api/user/get-notifications/', {}, true)

    if (response.status === 200) {
      messagesList.current = response.data
      setMessages(response.data)
    }
  }

  const handleChange = (event) => {
    setTable(event.target.value)
  }
  const [open, setOpen] = React.useState(false)
  const [logOut, setLogOut] = React.useState(false)

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleNFMenuOpen = (event) => {
    setAnchorNfEl(event.currentTarget)
  }
  // const handleProfileMenuClose = (event) => {
  //   setAnchorEl(null)
  // }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }
  useEffect(() => {
    const pathname = location.pathname.slice(1).toLowerCase()
    if (!pathname.startsWith('search/')) {
      setQuery('')
      setOpenSearch(false)
      setTable(0)
    }
  }, [location])
  const handleMenuClose = () => {
    setAnchorEl(null)
    handleMobileMenuClose()
  }
  const handleMenuNFClose = () => {
    setAnchorNfEl(null)
    // handleMobileMenuClose()
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  const fetchTables = async () => {
    let url = `${urls.getTables}`
    // let url = `${urls.getSearch}?id=${table}&search=${query}`

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setTables({ ...response.data })
    }
  }
  const fetchSuggestion = async () => {
    let url = `${urls.getSuggestions}`
    // let url = `${urls.getSearch}?id=${table}&search=${query}`

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setSuggestion([...response.data])
    }
  }
  const fetchSearch = async () => {
    navigate(`/search/${table}/${query}`)
    // let url = `${urls.getTables}`
    // let url = `${urls.getSearch}?id=${table}&search=${query}`

    // const response = await makeGetRequest(url, {}, false)
    // if (response.status === 200) {
    //   setSearchOutput({ ...response.data })
    //   // setOpen(true);
    // }
  }
  const onChange = (search) => {
    let filterSuggestion = []
    filterSuggestion = [
      ...suggestion
        .filter((e) => e.search.toLowerCase().startsWith(search.toLowerCase()))
        .slice(0, 10),
    ]
    if (search && filterSuggestion.length > 0) {
      setOpenSuggestion(true)
      setSuggestionFilter(filterSuggestion)
    } else {
      setOpenSuggestion(false)
    }
  }
  const searchSelect = (event) => {
    setQuery(event.target.innerText)
    navigate(`/search/${table}/${event.target.innerText}`)
    setOpenSuggestion(false)
  }
  const checkkey = (e) => {
    if (e.key === 'Enter') {
      fetchSearch()
      setOpenSuggestion(false)
    }
  }
  const handleClose = () => {
    setOpen(false)
  }
  const searchBox = (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}></Dialog>
  )

  const menuId = 'primary-search-account-menu'
  const menuNfId = 'primary-search-account-menu-nf'
  const RenderMenu = ({ setUoption }) => {
    return (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 6.8,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        // anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        id={menuId}
        keepMounted
        // transformOrigin={{
        //   vertical: 'top',
        //   horizontal: 'right',
        // }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuList>
          <MenuItem>
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              onClick={() => {
                setUoption(true)
                handleMenuClose()
              }}
            >
              {user.prenom} {user.nom}
            </ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setUoption(true)
              handleMenuClose()
            }}
          >
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('layout:nav.lifeSettings')}</ListItemText>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <DvrRoundedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              onClick={() => {
                dispatch(setSitePersonnaliser(true))
                navigate('/')
                handleMenuClose()
              }}
            >
              {t('layout:nav.personalize')}
            </ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              // LAP-733 (GE022) — the /subscription route is currently a
              // redirect to '/', so deep-link directly into the UserOptions
              // dialog on the Abonnement tab (index 4). UserOptions reads the
              // 'openab' localStorage flag on mount (mirroring the existing
              // 'opencc' deep-link for Connected Accounts).
              try {
                localStorage.setItem('openab', '1')
              } catch (_) {}
              setUoption(true)
              handleMenuClose()
            }}
          >
            <ListItemIcon>
              <StarBorder fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('layout:nav.subscription')}</ListItemText>
          </MenuItem>
          {/* <MenuItem onClick={() => navigate('/catalogue')}>
            <ListItemIcon>
              <AppRegistrationIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('layout:nav.lifeApps')}</ListItemText>
          </MenuItem> */}

          <MenuItem
            onClick={() => {
              setCPOpen(true)
              handleMenuClose()
            }}
          >
            <ListItemIcon>
              <MailOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('layout:nav.support')}</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setAppDetailOpen(true)
              handleMenuClose()
            }}
          >
            <ListItemIcon>
              <ErrorOutlineRoundedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('layout:nav.about')} </ListItemText>
          </MenuItem>
          {/* LAP-733 (GE022) — "App-Einstellungen" item retiré : il n'avait
              aucune action attachée et faisait double emploi avec « Life
              Einstellungen ». */}
          <MenuItem
            onClick={() => {
              setLogOut(true)
              handleMenuClose()
            }}
          >
            <ListItemIcon>
              <PowerSettingsNewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('layout:nav.logout')}</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    )
  }
  const NotificationMenu = ({ handleChangeTab }) => {
    return (
      <Menu
        anchorEl={anchorNfEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{ pt: 2 }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflowY: 'auto',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 6.8,
            bgcolor: '#121212',
            color: 'white',
            borderColor: 'white',
            border: '1px solid',
            minWidth: '500px',
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        id={menuNfId}
        keepMounted
        open={isMenuNFOpen}
        onClose={handleMenuNFClose}
        className="mobileNf"
      >
        <ArrowDropUpIcon
          sx={{ position: 'absolute', top: '-23px', fontSize: '40px', right: '0' }}
        />
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList textColor="inherit" onChange={handleChangeTab}>
                <Tab label={t('layout:nav.tabByDate')} value="1" />
                <Tab label={t('layout:nav.tabByType')} value="2" />
                <Tab label={t('layout:nav.tabByPriority')} value="3" />
              </TabList>
            </Box>
            <Box sx={{ borderTop: '1px solid #858585' }}>
              <TabPanel value="1" sx={{ padding: 0 }}>
                {ByDateNf}
              </TabPanel>
              <TabPanel value="2" sx={{ padding: 0 }}>
                {ByTypeNf}
              </TabPanel>
              <TabPanel value="3" sx={{ padding: 0 }}>
                {ByPrioriteNf}
              </TabPanel>
            </Box>
          </TabContext>
        </Box>
      </Menu>
    )
  }
  const delNotification = async (id) => {
    let filter = messages.filter((e) => e.id !== id)
    setMessages([...filter])
    makePostRequest('/api/user/read-notification/', { id }, {}, true)
  }
  const NfMList = ({ nfM }) => {
    return (
      <Box
        key={nfM.id}
        sx={{ position: 'relative', display: 'flex', padding: 1, borderBottom: '1px solid gray' }}
      >
        <CloseIcon
          onClick={() => delNotification(nfM.id)}
          sx={{
            color: 'white',
            position: 'absolute',
            right: '10px',
            top: '8px',
            cursor: 'pointer',
          }}
        />
        <Box
          display={'flex'}
          sx={{ cursor: 'pointer', width: '100%' }}
          onClick={() => {
            if (nfM.link) {
              navigate(nfM.link)
            }
          }}
        >
          <Box sx={{ width: '40px', marginRight: '10px' }}>
            <img alt="icon" src={nfM.priority_obj?.icon} />
          </Box>
          <Box>
            <Box>{nfM.name}</Box>
            <Box sx={{ fontStyle: 'italic', mt: 1 }}>{nfM.source || ''}</Box>
            <Box sx={{ color: 'gray', mt: 1 }}>
              {moment(nfM.created_at, 'YYYY-MM-DDThh:mm:ss').fromNow()}
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }
  const ByDateNf = (
    <Box>
      {messages.map((m) => (
        <NfMList key={m.id} nfM={m} />
      ))}
      {messages.length === 0 && (
        <Box textAlign={'center'} py={2}>
          {t('layout:nav.noNotifications')}
        </Box>
      )}
    </Box>
  )
  const ByTypeNf = (
    <Box>
      <List>
        {messagesType.map((mt, index) => (
          <Box key={index}>
            <ListItemButton
              onClick={() => {
                messagesType[index].open = !messagesType[index].open
                setMessagesType([...messagesType])
              }}
              sx={{ borderBottom: '1px solid gray' }}
            >
              {mt.open ? <ExpandLess /> : <ExpandMore />}
              <ListItemText sx={{ ml: 1 }} primary={`${mt.type} (${mt.list.length})`} />
            </ListItemButton>
            <Collapse in={mt.open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <Box pl={4}>
                  {mt.list.map((m) => (
                    <NfMList key={m.id} nfM={m} />
                  ))}
                </Box>
              </List>
            </Collapse>
          </Box>
        ))}
      </List>
      {messagesType.length === 0 && (
        <Box textAlign={'center'} py={2}>
          {t('layout:nav.noNotifications')}
        </Box>
      )}
    </Box>
  )
  const ByPrioriteNf = (
    <Box>
      {messagesPriority.map((m) => (
        <NfMList key={m.id} nfM={m} />
      ))}
      {messagesPriority.length === 0 && (
        <Box textAlign={'center'} py={2}>
          {t('layout:nav.noNotifications')}
        </Box>
      )}
    </Box>
  )
  const mobileMenuId = 'primary-search-account-menu-mobile'
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      sx={{ '.MuiPaper-root': { marginTop: '30px' } }}
    >
      <MenuItem
        onClick={() => {
          setOpenSearch(true)
          handleMobileMenuClose()
        }}
      >
        <ListItemIcon>
          <SearchIcon />
        </ListItemIcon>
        <Typography variant="inherit">{t('layout:nav.search')}</Typography>
      </MenuItem>
      <MenuItem
        onClick={(e) => {
          handleNFMenuOpen(e)
          handleMobileMenuClose()
        }}
      >
        <ListItemIcon>
          <Badge badgeContent={messages.length} id="notifi-counter" color="error">
            <NotificationsIcon />
          </Badge>
        </ListItemIcon>
        <Typography variant="inherit">{t('layout:nav.notifications')}</Typography>
      </MenuItem>
      <MenuItem
        onClick={(e) => {
          handleProfileMenuOpen(e)
        }}
      >
        <ListItemIcon>
          <AccountCircle />
        </ListItemIcon>
        <Typography variant="inherit">{t('layout:nav.profile')}</Typography>
      </MenuItem>
    </Menu>
  )

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" sx={{ backgroundColor: '#000000 !important' }}>
          <Toolbar>
            <NavLink to="/">
              <img src={logo} alt="" />{' '}
            </NavLink>
            <Box sx={{ minWidth: 120, flexGrow: 1 }} ml={4}>
              <SimpleListMenu />
            </Box>

            <Box p={1} display={'flex'} flexDirection={'row'}>
              {openSearch && (
                <Box className={'serchMenuMobile'} borderRadius={'5px'} p={1}>
                  <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
                    <InputLabel sx={{ color: 'white' }} id="table-select-small">
                      {t('layout:nav.searchObjet')}
                    </InputLabel>
                    <Select
                      labelId="table-select-small"
                      id="table-select-small"
                      value={table}
                      label={t('layout:nav.searchObjet')}
                      autoWidth={true}
                      placeholder={t('layout:nav.searchObjet')}
                      onChange={handleChange}
                      sx={{
                        color: 'white',
                        '.MuiSelect-icon': {
                          color: 'white',
                        },
                        '& fieldset': {
                          borderColor: 'white',
                        },
                      }}
                    >
                      <MenuItem value={0}>{t('common:labels.all')}</MenuItem>

                      {Object.keys(tables).map((item, i) => (
                        <MenuItem key={i} value={tables[item].id}>
                          {tables[item].Table_Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ m: 1 }} size="small">
                    <TextField
                      ref={inputQuery}
                      id="query"
                      lable={t('common:buttons.search')}
                      placeholder={t('common:buttons.search')}
                      onChange={(e) => {
                        onChange(e.target.value)
                        setQuery(e.target.value)
                      }}
                      autoFocus={true}
                      onKeyDown={checkkey}
                      value={query}
                      autoComplete="off"
                      sx={{
                        width: { md: 300 },
                        position: 'relative',
                        color: 'white',

                        '& label': {
                          color: 'white',
                        },
                        '& input': {
                          color: 'white',
                        },
                        '& input:hover': {
                          '& fieldset': {
                            borderColor: 'white',
                          },
                        },
                        '& label.Mui-focused': {
                          color: 'white',
                        },
                        '& fieldset': {
                          borderColor: 'white',
                        },
                        '.MuiOutlinedInput-input': {
                          padding: '8.5px 8px',
                        },
                      }}
                    />
                    <SearchIcon
                      onClick={() => fetchSearch()}
                      sx={{
                        display: { md: 'none' },
                        position: 'absolute',
                        right: 0,
                        marginTop: '9px',
                        marginRight: '3px',
                      }}
                    />
                    <ClearIcon
                      onClick={() => setOpenSearch(false)}
                      sx={{
                        display: { md: 'none' },
                        color: 'white',
                        // background: 'red',
                        borderRadius: 3,
                        cursor: 'pointer',
                        position: 'absolute',
                        right: '-22px',
                        top: '-15px',
                      }}
                    />
                    {openSuggestion && (
                      <Box
                        sx={{
                          position: 'absolute',
                          width: 300,
                          backgroundColor: '#727883',
                          top: '44px',
                          padding: '10px',
                          borderRadius: '5px',
                        }}
                      >
                        {suggestionFilter.map((item) => (
                          <Box
                            key={item.id}
                            onClick={searchSelect}
                            sx={{
                              padding: '3px 8px',
                              cursor: 'pointer',
                              borderRadius: '5px',
                              '&:hover': {
                                backgroundColor: '#9393939c',
                              },
                            }}
                          >
                            {item.search}
                          </Box>
                        ))}
                      </Box>
                    )}
                  </FormControl>
                </Box>
              )}
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <IconButton
                  onClick={() => {
                    if (openSearch) {
                      if (query === '') {
                        setOpenSearch(false)
                        navigate('/')
                      } else {
                        fetchSearch()
                        setOpenSuggestion(false)
                      }
                    } else {
                      setOpenSearch(true)

                      fetchTables()
                      fetchSuggestion()
                    }
                  }}
                  size="large"
                  color="inherit"
                >
                  <SearchIcon />
                </IconButton>
                <IconButton
                  size="large"
                  color="inherit"
                  aria-controls={menuNfId}
                  onClick={handleNFMenuOpen}
                >
                  <Badge badgeContent={messages.length} id="notifi-counter" color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <IconButton
                  size="large"
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                >
                  <Avatar alt="profile_img" src={user.img_url || '/tepprofile.png'} />
                </IconButton>
              </Box>
            </Box>
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        <RenderMenu setUoption={setUoption} />
        <NotificationMenu handleChangeTab={handleChangeTab} />
        {searchBox}
      </Box>
      {uoption && <UserOptions user={user} setUser={setUser} setUoption={setUoption} />}
      {logOut && <LogOut setLogOut={setLogOut} setUserSync={setUserSync} />}
      {cPOpen && <ContactSupport setCPOpen={setCPOpen} />}
      {appDetailOpen && <AppDetail setAppDetailOpen={setAppDetailOpen} />}
      <WebSocket url={wsUrl} onMessage={handleData} />
    </>
  )
}
export default NavBar2

function LogOut({ setLogOut, setUserSync }) {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(true)

  const handleClose = () => {
    setOpen(false)
    setLogOut(false)
  }
  const handleLogout = async () => {
    // Succès ou échec de l'appel serveur, la session locale est purgée de la
    // même façon : token, store Redux et userSync (via clearClientSession).
    try {
      await makePostRequest('/api/user/logout/', {}, {}, true)
    } catch (_) {
      // Réseau indisponible : on déconnecte quand même localement.
    }
    handleClose()
    setUserSync(false)
    clearClientSession(dispatch)
    navigate('/login')
  }

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t('dialogs.logoutConfirm')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogout}>{t('buttons.yes')}</Button>
          <Button onClick={handleClose}>{t('buttons.no')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

function ContactSupport({ setCPOpen }) {
  const { t } = useTranslation(['layout', 'common'])
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = React.useState(true)
  const [reason, setReason] = useState([])
  const [selectedReason, setSelectedReason] = useState('')
  const [object, setObject] = useState('')
  const [message, setMessage] = useState('')
  const [file, setFile] = useState(null)

  const { handleSubmit } = useForm({
    defaultValues: {},
  })

  useEffect(() => {
    getReasons()
  }, [])
  const getReasons = async () => {
    const response = await makeGetRequest('/api/user/support-reason/', {}, true)
    if (response.status === 200) {
      setReason(response.data)
    }
  }
  const onSubmit = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('file', file)
    formData.append('reason', selectedReason)
    formData.append('object', object)
    formData.append('message', message)

    makePostRequest(
      '/api/user/support-contact/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    alert(t('common:dialogs.mailSent'))
    handleClose()
  }
  const handleClose = () => {
    setOpen(false)
    setCPOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        maxWidth="md"
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <DialogContentText textAlign={'center'} pb={2} fontWeight={700}>
              {t('layout:support.contactSupport')}
            </DialogContentText>
            <Box minWidth={isMobile ? '100%' : 800}>
              <Box display={'flex'} alignItems={'center'}>
                <Box width={140} display={isMobile ? 'none' : 'block'}>
                  {t('layout:support.reasonLabel')}
                </Box>
                <Box width={'100%'}>
                  <FormControl fullWidth>
                    <Select
                      // autoWidth={true}
                      fullWidth
                      placeholder={t('common:labels.reason')}
                      size="small"
                      value={selectedReason}
                      required
                      onChange={(e) => {
                        // console.log(e.target.value)
                        setSelectedReason(e.target.value)
                      }}
                    >
                      <MenuItem value="">{t('common:labels.selectReason')}</MenuItem>
                      {reason.map((e) => (
                        <MenuItem key={e.id} name={e.reason} value={e.id}>
                          {e.reason}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} mt={2}>
                <Box width={140} display={isMobile ? 'none' : 'block'}>
                  {t('layout:support.objectLabel')}
                </Box>
                <Box width={'100%'}>
                  <TextField
                    onChange={(e) => setObject(e.target.value)}
                    fullWidth
                    required
                    placeholder={t('common:labels.subject')}
                    size="small"
                    sx={{ '.MuiInputBase-input': { boxShadow: 'unset' } }}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} mt={2}>
                <Box width={140} display={isMobile ? 'none' : 'block'}>
                  {t('layout:support.messageLabel')}
                </Box>
                <Box width={'100%'}>
                  <TextField
                    placeholder={t('common:labels.message')}
                    onChange={(e) => setMessage(e.target.value)}
                    fullWidth
                    multiline
                    rows={10}
                    required
                    size="small"
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} mt={2}>
                <Box width={140}>{t('layout:support.attachmentsLabel')}</Box>
                <Box width={'100%'}>
                  <Button
                    variant="contained"
                    component="label"
                    sx={{
                      color: 'black',
                      background: 'none',
                      '&:hover': {
                        backgroundColor: '#aeaeae',
                      },
                    }}
                  >
                    <input
                      name="file"
                      type="file"
                      // filename={file}
                      // accept="application/pdf"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </Button>
                </Box>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('common:buttons.submit')}</Button>
            <Button onClick={handleClose}>{t('common:buttons.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}

function AppDetail({ setAppDetailOpen }) {
  const { t } = useTranslation('layout')
  let location = useLocation()
  const pathname = location.pathname.slice(1).toLowerCase()

  const [open, setOpen] = React.useState(true)
  const [appDetail, setAppdetail] = useState({ Code: 'LIFEPAD', Version: '1.0' })

  useEffect(() => {
    getAppPropos()
  }, [])
  const getAppPropos = async () => {
    if (pathname) {
      const response = await makePostRequest('/api/base/app-propos/', { path: pathname }, {}, true)
      if (response.status === 200) {
        setAppdetail(response.data)
      }
    }
  }

  const handleClose = () => {
    setOpen(false)
    setAppDetailOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        maxWidth="md"
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText textAlign={'center'} pb={2} fontWeight={700}>
            {t('about.title')}
          </DialogContentText>
          <Box minWidth={700}>
            <Box color={'black'} fontWeight={700} py={2}>
              {t('about.application')}
            </Box>

            <Box sx={{ flexGrow: 1 }} mt={2}>
              <Grid container spacing={2} columns={16}>
                {appDetail?.Nom && (
                  <Grid item xs={8} color={'gray'}>
                    {t('about.name')}:
                    <Box color={'black'} fontWeight={500}>
                      {appDetail?.Nom}
                    </Box>
                  </Grid>
                )}
                {appDetail?.Code && (
                  <Grid item xs={8} color={'gray'}>
                    {t('about.id')}:
                    <Box color={'black'} fontWeight={500}>
                      {appDetail?.Code}
                    </Box>
                  </Grid>
                )}
                {appDetail?.Version && (
                  <Grid item xs={8} color={'gray'}>
                    {t('about.version')}:
                    <Box color={'black'} fontWeight={500}>
                      {appDetail?.Version}
                    </Box>
                  </Grid>
                )}
                {appDetail?.Groupe && (
                  <Grid item xs={8} color={'gray'}>
                    {t('about.component')}:
                    <Box color={'black'} fontWeight={500}>
                      {appDetail?.Groupe}
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
            <Divider sx={{ mt: 2, borderColor: '#000000c7' }} />
            <Box color={'black'} fontWeight={700} py={2} mt={2}>
              {t('about.system')}
            </Box>
            <Box sx={{ flexGrow: 1 }} mt={2}>
              <Grid container spacing={2} columns={16}>
                <Grid item xs={8} color={'gray'}>
                  {t('about.productVersion')}:
                  <Box color={'black'} fontWeight={500}>
                    LIFE CLOUD 2023
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Divider sx={{ mt: 2, borderColor: '#000000c7' }} />
            <Box color={'black'} fontWeight={700} py={2}>
              {t('about.environment')}
            </Box>
            <Box sx={{ flexGrow: 1 }} mt={2}>
              <Grid container spacing={2} columns={16}>
                <Grid item xs={8} color={'gray'}>
                  {t('about.deviceType')}:
                  <Box color={'black'} fontWeight={500}>
                    {t('about.desktop')}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
